import * as actions from './updateUserSecurityQuestionsActions';

const updateUserSecurityQuestionsReducers = {
  [actions.USER_UPDATE_USER_SECURITY_QUESTIONS_SUCCESS_RECEIVED]: (
    state,
    { payload }
  ) => {
    state.userSecurityQuestions = payload;
    return state;
  },
};

export default updateUserSecurityQuestionsReducers;
